import {
	BeBufferBar,
	BeKnobSwitch,
	BeMediaSlider,
	BePage,
	BeRow,
	BeStack,
	BeTransportButton,
	type BeTransportKind,
	BeVolumeSlider,
} from "@beos-css/react/index.ts";

const KINDS: BeTransportKind[] = ["rewind", "stop", "play", "forward", "zoom"];

export function MediaControlsDemo() {
	return (
		<section id="demo-media-controls">
			<h2>Media controls (TransportButton, TMultiThumbMediaSlider, TVolumeSlider, KnobSwitch)</h2>
			<p>
				MediaPlayer's transport controls, each state its own bitmap from the app. Press a button to see the frame it shows while held; the
				paused Play button blinks its LED.
			</p>

			<h3>Transport buttons</h3>
			<BePage className="be-panel" pad={1}>
				<BeStack gap="row">
					{(["default", "pressed", "focused", "disabled"] as const).map((state) => (
						<BeRow key={state} gap="item">
							{KINDS.map((kind) => (
								<BeTransportButton
									key={kind}
									kind={kind}
									disabled={state === "disabled"}
									className={state === "pressed" ? "is-pressed" : state === "focused" ? "is-focus" : undefined}
								/>
							))}
						</BeRow>
					))}
					<BeRow gap="item">
						<BeTransportButton kind="play" playState="playing" />
						<BeTransportButton kind="play" playState="playing" className="is-pressed" />
						<BeTransportButton kind="play" playState="paused" />
					</BeRow>
				</BeStack>
			</BePage>

			<h3>Seek, volume and buffer</h3>
			<BePage className="be-panel" pad={1}>
				<BeStack gap="row">
					<BeMediaSlider duration={214} position={29.00048} />
					<BeMediaSlider duration={214} position={120} inPoint={40} outPoint={180} />
					<BeMediaSlider duration={0} position={0} disabled />
					<BeRow gap="item">
						<BeVolumeSlider defaultValue={0} />
						<BeVolumeSlider defaultValue={70} />
						<BeVolumeSlider defaultValue={100} />
						<BeVolumeSlider defaultValue={70} disabled />
					</BeRow>
					<BeBufferBar value={60} />
				</BeStack>
			</BePage>

			<h3>Mini-mode twistie</h3>
			<BePage className="be-panel" pad={1}>
				<BeRow gap="item">
					<BeKnobSwitch on={false} />
					<BeKnobSwitch on />
					<BeKnobSwitch on className="is-pressed" />
					<BeKnobSwitch on className="is-focus" />
				</BeRow>
			</BePage>
		</section>
	);
}
